var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'Login')?_c('router-view'):_c('el-container',[_c('el-header',[_c('TopNav')],1),_c('el-container',{staticStyle:{"max-height":"calc(100% - 80px)"}},[_c('el-aside',{style:({ width: _vm.pageWidth < 768 ? '64px' : '300px' })},[_c('SideNav')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }